import React, { useState, useEffect } from "react";
import { useSearchParams } from "react-router-dom";
import { Row, Col, Button, InputGroup, Form } from "react-bootstrap";
import { ActionHandlerFunction, PaginationItem } from "@preveil-api";
import { DriveUIActionTypes, QueryParamKeys, QueryParamValues } from "src/common";
import { Icon, Pagination, PaginationDisplay } from "src/components";

type AllProps = {
  is_loading: boolean;
  pagination?: PaginationItem;
  selected: string[];
  counts?: number;
  handleAction: ActionHandlerFunction;
}

function ToolbarComponent(props: AllProps) {
  const { is_loading, pagination, selected, counts, handleAction } = props;
  // NOTE: to enable it for internal users: /drive/watched/root?action=enable_clear_all to see the clear all button
  const [searchParams, setSearchParams] = useSearchParams();
  const [enable_clear_all, setEnableClearAll] = useState<boolean>(false);
  const [disabled, setDisabled] = useState<boolean>(true);
  const [filter_param, setFilterParam] = useState<string>("");

  useEffect(() => {
    const page_action_qs = searchParams.get(QueryParamKeys.PAGE_ACTION_QUERY_KEY);
    if (!!page_action_qs && page_action_qs === QueryParamValues.enable_clear_all) {
      searchParams.delete(QueryParamKeys.PAGE_ACTION_QUERY_KEY);
      setSearchParams(searchParams);
      setEnableClearAll(true);
    }
  }, []);

  useEffect(() => {
    (!!pagination && pagination.totalRows > 0) ?
      setDisabled(selected.length <= 0) : setDisabled(true);
  }, [selected, pagination]);

  // Description: reset filters on pagination and on click of x
  function resetFilters() {
    setFilterParam("");
    handleAction({ actionType: DriveUIActionTypes.Filter, params: "" });
  }

  return <Row className="toolbar watched">
    {
      <>
        <Col xs="auto" className="ps-0 ms-1 col-sm-5">
          <InputGroup size="sm">
            <InputGroup.Text>
              <Icon className="ficon-filter" />
            </InputGroup.Text>
            <Form.Control
              id="filter_tb"
              size="sm"
              autoComplete="off"
              disabled={is_loading}
              value={filter_param}
              onChange={(e) => {
                setFilterParam(e.target.value);
                handleAction({ actionType: DriveUIActionTypes.Filter, params: e.target.value });
              }}
              type="text"
              placeholder="Filter by items name in this page..."
              aria-label="Filter" />
            {
              filter_param &&
              <Button
                variant="icon"
                size="sm"
                className="input-group-btn"
                onClick={resetFilters} >
                <Icon className="ficon-x-circle" />
              </Button>
            }
          </InputGroup>
        </Col>
        <Col className="order-1">
          <Button
            variant="icon"
            size="sm"
            disabled={disabled}
            onClick={() => handleAction({ actionType: DriveUIActionTypes.Unwatch, params: selected })}
            aria-label="Unwatch Selected"
            data-tooltip-id="tb-tooltip"
            data-tooltip-content="Unwatch Selected">
            <Icon className="ficon-eye-off" />
          </Button>
          {
            enable_clear_all &&
            <Button
              variant="icon"
              size="sm"
              disabled={!counts}
              onClick={() => handleAction({ actionType: DriveUIActionTypes.ClearAllWatched, params: selected })}
              aria-label="Clear All Watched"
              data-tooltip-id="tb-tooltip"
              data-tooltip-content="Clear All Watched">
              <Icon className="ficon-trash-2" />
            </Button>
          }
        </Col>
        <Col xs="auto" className="order-sm-2 order-3 ms-auto">
          {
            !!pagination &&
            <Pagination
              className="mb-0 justify-content-end"
              pagination={pagination}
              handleAction={(params) => {
                resetFilters();
                handleAction(params);
              }} />
          }
        </Col>
        <Col xs="auto" className="order-sm-3 order-4 me-2">
          {!!pagination && <PaginationDisplay pagination={pagination} />}
        </Col>
        <Col className="divider order-sm-3 order-1"></Col>
        <Col xs="auto" className="p-0 order-sm-3 order-4 ms-1 refresh" >
          <Button variant="icon"
            size="sm"
            data-tooltip-id="tb-tooltip" data-tooltip-content="Refresh"
            onClick={() => {
              resetFilters();
              handleAction({ actionType: DriveUIActionTypes.Refresh });
            }}
            title="Refresh Current Folder">
            {
              is_loading ?
                <i className="spinner"></i> :
                <Icon className="ficon-rotate-cw" />
            }
          </Button>
        </Col>
      </>
    }
  </Row>;
}

export default React.memo(ToolbarComponent);